import { createSelector } from 'reselect'
import { State } from 'index'

const pushMessageSelector = (state: State) => state.pushMessage

export const getPushMessages = createSelector([pushMessageSelector], (state) => state.pushMessages)
